import React from "react";
import { Link } from "react-router-dom";

export default function Danke() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      {/* Karte */}
      <div className="w-full max-w-md bg-white p-8 rounded-xl shadow-lg text-center">
        <h1 className="text-3xl md:text-4xl font-bold mb-4">
          Danke für Ihre Nachricht!
        </h1>

        <p className="text-gray-700 leading-relaxed">
          Wir melden uns schnellstmöglich bei&nbsp;Ihnen.
        </p>

        {/* Zurück-Button */}
        <Link
          to="/"
          className="inline-block mt-6 px-6 py-3 bg-black text-white rounded-md hover:bg-gray-800 transition"
        >
          Zurück zur Startseite
        </Link>
      </div>
    </div>
  );
}

